import { useMemo } from "react";
import { gql, useQuery } from "@apollo/client";

const AGREEMENT_VARIABLES = gql`
  query AgreementVariablesForEdit {
    agreementVariables {
      key
      description
      type
      location
    }
  }
`;

export interface AgreementVariable {
  key: string;
  description: string;
  type: string;
  location: string;
}

export interface VariableMenuItem {
  text: string;
  value: string;
}

export function getVariableItemsFromRegistry(
  variables: AgreementVariable[],
): VariableMenuItem[] {
  const items: VariableMenuItem[] = [];
  for (const v of variables) {
    if (v.type === "customer") {
      items.push({ text: `${v.description} (numbered)`, value: `{{${v.key}_1}}` });
      items.push({ text: `${v.description} (list)`, value: `{{${v.key}_list}}` });
    } else {
      items.push({ text: v.description, value: `{{${v.key}}}` });
    }
  }
  return items;
}

export function useAgreementVariables() {
  const { data, loading, error } = useQuery<{
    agreementVariables: AgreementVariable[];
  }>(AGREEMENT_VARIABLES, { fetchPolicy: "cache-first" });

  const variables = data?.agreementVariables ?? [];
  const items = useMemo(() => getVariableItemsFromRegistry(variables), [variables]);

  return { variables, items, loading, error };
}
